/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CsrfTokenInfo,
    CsrfTokenInfoFromJSON,
    CsrfTokenInfoToJSON,
    UserAuthInfo,
    UserAuthInfoFromJSON,
    UserAuthInfoToJSON,
} from '../models';

/**
 * AuthApi - interface
 * 
 * @export
 * @interface AuthApiInterface
 */
export interface AuthApiInterface {
    /**
     * 
     * @summary Get authenticated user information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    getAuthInfoRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<UserAuthInfo>>;

    /**
     * Get authenticated user information
     */
    getAuthInfo(initOverrides?: RequestInit): Promise<UserAuthInfo>;

    /**
     * 
     * @summary csrf
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    getCsrfTokenRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<CsrfTokenInfo>>;

    /**
     * csrf
     */
    getCsrfToken(initOverrides?: RequestInit): Promise<CsrfTokenInfo>;

}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI implements AuthApiInterface {

    /**
     * Get authenticated user information
     */
    async getAuthInfoRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<UserAuthInfo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/web/auth/info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserAuthInfoFromJSON(jsonValue));
    }

    /**
     * Get authenticated user information
     */
    async getAuthInfo(initOverrides?: RequestInit): Promise<UserAuthInfo> {
        const response = await this.getAuthInfoRaw(initOverrides);
        return await response.value();
    }

    /**
     * csrf
     */
    async getCsrfTokenRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<CsrfTokenInfo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/web/auth/csrf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CsrfTokenInfoFromJSON(jsonValue));
    }

    /**
     * csrf
     */
    async getCsrfToken(initOverrides?: RequestInit): Promise<CsrfTokenInfo> {
        const response = await this.getCsrfTokenRaw(initOverrides);
        return await response.value();
    }

}
